var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('div',{staticClass:"header",attrs:{"slot":"header"},slot:"header"},[_c('h3',[_vm._v(_vm._s(_vm.assistant.name))]),_c('p',[_vm._v(_vm._s(_vm.assistant.email))])]),(! _vm.assistant.verified)?_c('div',[_c('i',{staticClass:"el-icon-check"}),_vm._v(" Email invitation sent\n\t")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }